import React from 'react';
import moment from 'moment';
import { translate } from 'react-i18next';

// Components
import ExtComp from '../../../../components/external';

// Service
import { parseWeekDayToString, getDayTimePeriodString } from 'src/services/date';
import { campusTitle, parseDate } from '../../../../services/jobParsingData';

// Styles
import s from './RescheduleDetailsSection.style';


const RescheduleDetailsSection = (props) => {
  const { t, job } = props;

  return (
    <s.JobDetailsBlock className="job-details">
      {/* ──── Job details ─────────────────────────────────────────────────────────────────────── */}
      <div className="column">
        <p className="column-title">{t('job')}</p>

        <div className="column-row">
          <div className="half-row">
            <p className="sub-title">{t('job_type')}</p>
            <p>{t('job_type_reschedule')}</p>
          </div>
          <div className="half-row">
            <p className="sub-title">{t('job_states')}</p>
            <p>{job && job.status || t('no_data')}</p>
          </div>
        </div>

        <div className="column-row">
          <div className="half-row">
            <p className="sub-title">{t('job_created')}</p>
            <p>{parseDate(job && job.createdAt)}</p>
          </div>
          <div className="half-row">
            <p className="sub-title">{t('created_by')}</p>
            <p>{job && job.createdBy && job.createdBy.name || t('no_data')}</p>
          </div>
        </div>

        <div className="column-row">
          <p className="sub-title">{t('job_completion')}</p>
          <p>{parseDate(job && job.completedAt)}</p>
        </div>
      </div>

      {/* ──── Appointment ─────────────────────────────────────────────────────────────────────── */}
      <div className="column">
        <p className="column-title">{t('appointments')}</p>
        <div className="column-row small-margin-bottom">
          <div className="half-row">
            <p className="sub-title">{t('appointments_date')}</p>
            <p>{job && job.goalsDate ?
              moment(job.goalsDate).format('DD.MM.YYYY dddd')
              : t('no_data')}
            </p>
          </div>
          <div className="half-row">
            <p className="sub-title">{t('appointments_selected')}</p>
            <p>{job && job.countGoals || t('no_data')}</p>
          </div>
        </div>

        <div className="column-row small-margins">
          {job && job.practitioner ?
            <ExtComp.PractitionerBlock practitioner={job.practitioner} />
            : t('no_data')
          }
        </div>

        <div className="column-row small-margins">
          <ExtComp.CampusBlock title={campusTitle(job)} />
        </div>

      </div>

      {/* ──── Details ─────────────────────────────────────────────────────────────────────────── */}
      <div className="column">
        <p className="column-title">{t('Details')}</p>

        {/*  Date  */}
        {job && job.rescheduleDate ? <div className="column-row small-margins">
          <p className="sub-title">{t('earliest_reschedule_date')}</p>
          <p>{moment(job.rescheduleDate).format('DD.MM.YYYY dddd')}</p>
        </div>
          : null}

        <div className="column-row small-margins">
          {/*  Appointment type  */}
          {job && job.appointmentTypeSettings ? <div className="half-row">
            <p className="sub-title">{t('resch_appointment_type')}</p>
            {job.appointmentTypeSettings.type === 'original' ?
              <p>{t('appoint_type_option_0')}</p> :
              <p>{`${t('appoint_type_option_1')} : ${job.appointmentTypeSettings.typeId || t('no_data')}`}</p>
            }
          </div>
            : null}

          {/*  Schedule type  */}
          {job && job.scheduleSettings ? <div className="half-row">
            <p className="sub-title">{t('schedule')}</p>
            {job.scheduleSettings.type === 'original' ?
              <p>{t('schedule_option_0')}</p> :
              <p>{`${t('schedule_option_1')} : ${job.scheduleSettings.scheduleId || t('no_data')}`}</p>
            }
          </div>
            : null}
        </div>


        <div className="column-row small-margins">
          {/*  Appointment day of week  */}
          {job && job.daySettings && job.daySettings.dayOfWeekType ? <div className="half-row">
            <p className="sub-title">{t('appoint_day_of_week')}</p>
            {job.daySettings.dayOfWeekType === 'original' ? <p>{t('appoint_day_of_week_option_0')}</p> : null}
            {job.daySettings.dayOfWeekType === 'newByUser' ? <p>{`${t('appoint_day_of_week_option_1')} : ${parseWeekDayToString(job.daySettings.days)}`}</p> : null}
            {job.daySettings.dayOfWeekType === 'newByPatient' ? <p>{t('appoint_day_of_week_option_2')} </p> : null}
          </div>
            : null}

          {/*  Part of day  */}
          {job && job.daySettings && job.daySettings.partOfDayType ? <div className="half-row">
            <p className="sub-title">{t('appoint_part_of_day')}</p>
            {job.daySettings.partOfDayType === 'original' ? <p>{t('appoint_part_of_day_option_0')}</p> : null}
            {job.daySettings.partOfDayType === 'newByPatient' ? <p>{t('appoint_part_of_day_option_2')}</p> : null}
            {job.daySettings.partOfDayType === 'newByUser' ?
              <p>{`${t('appoint_part_of_day_option_1')} : ${
                Array.isArray(job.daySettings.partsOfDay) && getDayTimePeriodString(job.daySettings.partsOfDay) || t('no_data')}`
              }</p>
              : null}
          </div>
            : null}
        </div>
      </div>

    </s.JobDetailsBlock>
  );
};

export default translate()(RescheduleDetailsSection);
